let onsiteBookingCols = [
    {
        key: 'typeLabel',
        display: 'Type'
    },
    {
        key: 'makeLabel',
        display: 'Make'
    },
    {
        key: 'modelLabel',
        display: 'Model'
    },
    {
        key: 'imeiNo',
        display: 'IMEI'
    },
    {
        key: 'serialNo',
        display: 'Serial'
    },
    {
        key: 'label',
        display: 'Provider'
    },
    {
        key: 'providerBookingRef',
        display: 'Booking ref'
    },
    {
        key: 'orderId',
        display: 'Order Id'
    },
    {
        key: 'appointmentDate',
        display: 'Appointment Date'
    },
    {
        key: 'createdDate',
        display: 'Selected Date'
    },
    {
        key: 'cancelledDate',
        display: 'Cancelled Date'
    },
    {
        key: 'emailAddress',
        display: 'Cancelled By'
    }
]

export { onsiteBookingCols }